import { useParams, useNavigate } from 'react-router-dom'
import { Fragment } from 'react'

type SubItem = { id: string; label: string }
type Group = { id: string; label: string; items: SubItem[] }

// Sections that are entity lists (use routes) vs field sections (use anchors)
const ENTITY_SECTIONS = new Set([
	'linked-accounts',
	'billing-profiles', 
	'workspace-users',
	'workspace-locations',
	'workspace-domains',
	'workspace-phone-numbers',
	'workspace-data-sources',
	'workspace-connections',
])

// Map section IDs to entity routes
const SECTION_TO_ENTITY_MAP: Record<string, string> = {
	'linked-accounts': 'linked-accounts',
	'billing-profiles': 'billing-profiles',
	'workspace-users': 'users',
	'workspace-locations': 'locations',
	'workspace-domains': 'domains',
	'workspace-phone-numbers': 'phone-numbers',
	'workspace-data-sources': 'data-sources',
	'workspace-connections': 'connections',
}

export function SettingsSubnav({ groups }: { groups: Group[] }) {
	const { workspaceId } = useParams<{ workspaceId: string }>()
	const navigate = useNavigate()

	const handleClick = (id: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault()
		
		if (ENTITY_SECTIONS.has(id)) {
			// Navigate to entity route for list sections
			const entity = SECTION_TO_ENTITY_MAP[id]
			if (entity && workspaceId) {
				navigate(`/${workspaceId}/settings/${entity}`)
			}
		} else {
			// Use anchor scrolling for field sections
			document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
			history.replaceState(null, '', `#${id}`)
		}
	}

	return (
		<nav aria-label="Settings sections" className="py-2 pr-4">
			<ul className="space-y-2">
				{groups.map((group) => (
					<Fragment key={group.id}>
						<li>
							<a
								href={`#${group.id}`}
								onClick={handleClick(group.id)}
								className="block text-sm text-foreground"
							>
								{group.label}
							</a>
						</li>
						{group.items.map((item) => (
							<li key={item.id} className="pl-4">
								<a
									href={`#${item.id}`}
									onClick={handleClick(item.id)}
									className="block text-sm text-foreground"
								>
									{item.label}
								</a>
							</li>
						))}
					</Fragment>
				))}
			</ul>
		</nav>
	)
}


